import type { PermissionKey, SessionUser } from "@grizzly/shared";
import type { MessageKey } from "../i18n/index.js";
import {
  Building2,
  ClipboardList,
  FileText,
  HandCoins,
  LayoutDashboard,
  Package,
  ScrollText,
  Settings,
  ShoppingCart,
  Users,
  Wrench,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  labelKey: MessageKey;
  icon: LucideIcon;
  permission: PermissionKey | "dashboard";
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/", labelKey: "nav.dashboard", icon: LayoutDashboard, permission: "dashboard" },
  {
    to: "/customers",
    labelKey: "nav.customers",
    icon: Users,
    permission: "customers:read",
  },
  {
    to: "/quotes",
    labelKey: "nav.quotes",
    icon: ClipboardList,
    permission: "quotes:manage",
  },
  {
    to: "/catalog",
    labelKey: "nav.catalog",
    icon: Package,
    permission: "quotes:manage",
  },
  { to: "/jobs", labelKey: "nav.jobs", icon: Wrench, permission: "jobs:manage" },
  {
    to: "/shop-floor",
    labelKey: "nav.shopFloor",
    icon: Building2,
    permission: "shopfloor:view",
  },
  {
    to: "/materials",
    labelKey: "nav.materials",
    icon: Package,
    permission: "purchasing:manage",
  },
  {
    to: "/purchasing",
    labelKey: "nav.purchasing",
    icon: ShoppingCart,
    permission: "purchasing:manage",
  },
  {
    to: "/invoices",
    labelKey: "nav.invoices",
    icon: HandCoins,
    permission: "finance:manage",
  },
  {
    to: "/reports",
    labelKey: "nav.reports",
    icon: ScrollText,
    permission: "reports:ops",
  },
  {
    to: "/documents",
    labelKey: "nav.documents",
    icon: FileText,
    permission: "attachments:read",
  },
  { to: "/admin/users", labelKey: "nav.users", icon: Users, permission: "users:manage" },
  {
    to: "/admin/imports",
    labelKey: "nav.imports",
    icon: FileText,
    permission: "settings:manage",
  },
  {
    to: "/admin/audit-trail",
    labelKey: "nav.auditTrail",
    icon: ScrollText,
    permission: "audit:read",
  },
  {
    to: "/settings",
    labelKey: "nav.settings",
    icon: Settings,
    permission: "settings:manage",
  },
];

export function visibleNav(user: SessionUser): NavItem[] {
  return NAV_ITEMS.filter((item) => {
    if (item.permission === "dashboard") return true;
    return user.permissions.includes(item.permission);
  });
}

export const ROLE_ICON: Record<string, LucideIcon> = {
  owner_admin: ScrollText,
  office_planner: ShoppingCart,
  operator: Wrench,
};
